var AssetDirectory = {
	"load": [
		"assets/.DS_Store",
		"assets/bgm/bgm.ogg",
		"assets/game/combo_fx_ske.json",
		"assets/game/combo_fx_tex.json",
		"assets/game/combo_fx_tex.png",
		"assets/game/fx_firsttimeplay_glow.png",
		"assets/game/gfx_gamebg.png",
		"assets/game/gfx_titlebg.png",
		"assets/game/gfx_titlegizmo.png",
		"assets/game/gfx_titlelogo.png",
		"assets/game/htp_mustard1.png",
		"assets/game/htp_mustard2.png",
		"assets/game/htp_mustard3.png",
		"assets/game/htp_mustard4.png",
		"assets/game/htp_mustard5.png",
		"assets/game/mustard_growth_ske.json",
		"assets/game/mustard_growth_tex.json",
		"assets/game/mustard_growth_tex.png",
		"assets/sfx/button_sfx.ogg",
		"assets/sfx/gizmo_positive_01.ogg",
		"assets/sfx/gizmo_positive_02.ogg",
		"assets/sfx/gizmo_positive_03.ogg",
		"assets/sfx/gizmo_positive_04.ogg",
		"assets/sfx/gizmo_positive_05.ogg",
		"assets/sfx/plant_grow.ogg",
		"assets/sfx/plant_harvest.ogg",
		"assets/sfx/plant_select.ogg",
		"assets/sfx/score_points.ogg",
		"assets/sfx/star_gain.ogg",
		"assets/sfx/wrong_plant.ogg",
		"assets/ui/btn_audio1.png",
		"assets/ui/btn_audio2.png",
		"assets/ui/btn_audio3.png",
		"assets/ui/btn_audio4.png",
		"assets/ui/btn_close.png",
		"assets/ui/btn_exit.png",
		"assets/ui/btn_exit2.png",
		"assets/ui/btn_pause.png",
		"assets/ui/btn_pause2.png",
		"assets/ui/btn_play.png",
		"assets/ui/btn_play2.png",
		"assets/ui/btn_prevnext.png",
		"assets/ui/btn_prevnext2.png",
		"assets/ui/btn_replay.png",
		"assets/ui/btn_replay2.png",
		"assets/ui/btn_return.png",
		"assets/ui/btn_return2.png",
		"assets/ui/check-button1.png",
		"assets/ui/check-button2.png",
		"assets/ui/gfx_container.png",
		"assets/ui/gfx_container_white.png",
		"assets/ui/gfx_explode.png",
		"assets/ui/gfx_flare_long.png",
		"assets/ui/gfx_flare_star.png",
		"assets/ui/gfx_loading_bar_con.png",
		"assets/ui/gfx_pop.png",
		"assets/ui/gfx_pop2.png",
		"assets/ui/gfx_star0.png",
		"assets/ui/gfx_star1.png",
		"assets/ui/gfx_starbg.png",
		"assets/ui/x-button1.png",
		"assets/ui/x-button2.png"
	],
	"preload": [
		"assets/preload/fonts/Exo-Bold.otf",
		"assets/preload/fonts/Exo-Medium.ttf",
		"assets/preload/fonts/proximanova-black.otf",
		"assets/preload/strings/strings.json",
		"assets/preload/ui/gfx_bg.png",
		"assets/preload/ui/gfx_loading.png",
		"assets/preload/ui/gizmoloading_ske.json",
		"assets/preload/ui/gizmoloading_tex.json",
		"assets/preload/ui/gizmoloading_tex.png"
	],
	"preloadstring": []
};